module.exports = __webpack_public_path__ + "img/features-02-image.fbec085b.png";